import React from 'react';
import numbro from 'numbro';
import PeriodLabel from '../PeriodLabel';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import get from 'lodash/get';
import usePprStats, { KPI_STATUS_TYPE } from '../../hooks/usePprStats';

const PPRSummary = React.memo(props => {
  const { ppr, classes, onPositive, onFailed } = props;
  console.log('>>PPRSummary/index::', 'ppr', ppr); //TRACE

  const { kpiByKey } = usePprStats(ppr);
  console.log('>>PPRSummary/index::', 'stats', kpiByKey); //TRACE
  React.useEffect(() => {
    let positive = true;
    Object.values(kpiByKey).forEach(result => {
      if (result === 'NEGATIVE') positive = false;
    });
    if (positive) {
      onPositive && onPositive();
    } else {
      onFailed && onFailed();
    }
  }, [kpiByKey, onPositive, onFailed]);
  function getFieldStyles(field) {
    const color = KPI_STATUS_TYPE[kpiByKey[field]].color;
    if (color) return { color };
    return {};
  }
  return (
    <div className={classes.root}>
      {/* <Divider />
      <strong>
        <PeriodLabel period={ppr.period} />
      </strong> 
      <Divider />*/}
      <div className={classes.listSummary}>
        <div className={classes.headersRow}>
          <div className={classes.c1} />
          <div className={classes.c2}>GP$</div>
          <div className={classes.c3}>Customers</div>
          <div className={classes.c4}>UPT</div>
        </div>
        <div>
          <div className={classes.c1}>Targets</div>
          <div className={classes.c2} style={getFieldStyles('targetWeeklyGp')}>
            {numbro(get(ppr, 'targetWeeklyGp') || 0).formatCurrency({
              thousandSeparated: true,
              mantissa: 0,
            })}
          </div>
          <div className={classes.c3} style={getFieldStyles('targetHourLyCustomers')}>
            {get(ppr, 'targetHourLyCustomers') || 0}
          </div>
          <div className={classes.c4} style={getFieldStyles('targetWeeklyUpt')}>
            {get(ppr, 'targetWeeklyUpt') || 0}
          </div>
        </div>
        <div>
          <div className={classes.c1}>Actual</div>
          <div className={classes.c2} style={getFieldStyles('actualWeeklyGp')}>
            {' '}
            {numbro(get(ppr, 'actualWeeklyGp') || 0).formatCurrency({
              thousandSeparated: true,
              mantissa: 0,
            })}
          </div>
          <div className={classes.c3} style={getFieldStyles('actualHourLyCustomers')}>
            {get(ppr, 'actualHourLyCustomers') || 0}
          </div>
          <div className={classes.c4} style={getFieldStyles('actualWeeklyUpt')}>
            {get(ppr, 'actualWeeklyUpt') || 0}
          </div>
        </div>
        <div>
          <div className={classes.c1}>Coach's Comments</div>
          <div className={classes.c2full}>{get(ppr, 'managerFeedback.body', '')}</div>
        </div>
        <div>
          <div className={classes.c1}>Plan</div>
          <div className={classes.c2full}>{get(ppr, 'plan', '')}</div>
        </div>
      </div>
    </div>
  );
});
const styles = theme => ({
  root: { ...theme.typography },
  headersRow: { fontWeight: 'bold', fontSize: 'larger' },
  targetsRow: {},
  listSummary: {
    width: 450,
    '& > div > div': {
      display: 'inline-block',
      marginTop: 10,
    },
  },
  c1: { width: 180, fontSize: 'larger', verticalAlign: 'top' },
  c2: { width: 80 },
  c2full: { width: 240 },
  c3: { width: 120 },
  c4: { width: 70 },
});
export default withStyles(styles)(PPRSummary);
